/**
 * package: com.inq.flash.messagingframework
 * class: TranscriptEntry
 * root Object
 * @constructor
 */
com.inq.flash.messagingframework.TranscriptEntry = function() {
	this.timestamp = Math.floor(new Date().getTime() % 1000.0);
};
$hxClasses['com.inq.flash.messagingframework.TranscriptEntry'] = com.inq.flash.messagingframework.TranscriptEntry;
/** @private @type {Array} */
com.inq.flash.messagingframework.TranscriptEntry.__name__ = ["com","inq","flash","messagingframework","TranscriptEntry"];

/**
 * getData
 *
 * $type TFun([],TInst(String,[]))
 * public function getData():String
 * @public
 * @this com.inq.flash.messagingframework.TranscriptEntry
 * @return {string}
 */
com.inq.flash.messagingframework.TranscriptEntry.prototype.getData = function() {
	return this.data;
};


/**
 * getType
 *
 * $type TFun([],TInst(String,[]))
 * public function getType():String
 * @public
 * @this com.inq.flash.messagingframework.TranscriptEntry
 * @return {string}
 */
com.inq.flash.messagingframework.TranscriptEntry.prototype.getType = function() {
	return this.type;
};


/**
 * getSender
 *
 * $type TFun([],TInst(String,[]))
 * public function getSender():String
 * @public
 * @this com.inq.flash.messagingframework.TranscriptEntry
 * @return {string}
 */
com.inq.flash.messagingframework.TranscriptEntry.prototype.getSender = function() {
	return this.sender;
};


/**
 * getTimestamp
 *
 * $type TFun([],TInst(Int,[]))
 * public function getTimestamp():Int
 * @public
 * @this com.inq.flash.messagingframework.TranscriptEntry
 * @return {number}
 */
com.inq.flash.messagingframework.TranscriptEntry.prototype.getTimestamp = function() {
	return this.timestamp;
};


/**
 * setData
 *
 * $type TFun([{ name => data, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * public function setData(data:String):Void
 * @public
 * @this com.inq.flash.messagingframework.TranscriptEntry
 * @param {string}  data 
 * @return {void}
 */
com.inq.flash.messagingframework.TranscriptEntry.prototype.setData = function(data) {
	this.data = data;
};


/**
 * setType
 *
 * $type TFun([{ name => type, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * public function setType(type:String):Void
 * @public
 * @this com.inq.flash.messagingframework.TranscriptEntry
 * @param {string}  type 
 * @return {void}
 */
com.inq.flash.messagingframework.TranscriptEntry.prototype.setType = function(type) {
	this.type = type;
};


/**
 * setSender
 *
 * $type TFun([{ name => sender, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * public function setSender(sender:String):Void
 * @public
 * @this com.inq.flash.messagingframework.TranscriptEntry
 * @param {string}  sender 
 * @return {void}
 */
com.inq.flash.messagingframework.TranscriptEntry.prototype.setSender = function(sender) {
	this.sender = sender;
};

/** @private @type {string} */
com.inq.flash.messagingframework.TranscriptEntry.prototype.data = null;
/** @private @type {string} */
com.inq.flash.messagingframework.TranscriptEntry.prototype.type = null;
/** @private @type {string} */
com.inq.flash.messagingframework.TranscriptEntry.prototype.sender = null;
/** @private @type {number} */
com.inq.flash.messagingframework.TranscriptEntry.prototype.timestamp = null;
/** @type {com.inq.flash.messagingframework.TranscriptEntry} */
com.inq.flash.messagingframework.TranscriptEntry.prototype.__class__ = com.inq.flash.messagingframework.TranscriptEntry;
